import { ModuleNode } from "../types";
import { DrawerTypes } from '../../DataEstate/SideDrawers/constants';

// Data Estate
export const dataEstateModule: ModuleNode = {
  key: "dataestate",
  title: "D&AI Executive",
  pages: [
    {
      key: "executive-summary",
      title: "Executive Summary",
      route: "/dataestate/executive-summary",
      items: [
        // Size
        { key: "data-stored", label: "Data Stored", tags: ["size","storage","summary"] },
        {
              key: "data-stored-in-adls-&-blob",
              label: "Data Stored in ADLS & Blob",
              tags: ["data", "storage", "adls", "blob"],
              drawerType: DrawerTypes.DAI_PLATEFORMS,
              drawerProps: {
                title: "Data Stored",
                selectedDate: "2023-01",
                sector: []
              }
            },
            {
              key: "data-stored-in-teradata",
              label: "Data Stored in Teradata",
              tags: ["data", "storage", "teradata"],
              drawerType: DrawerTypes.DAI_PLATEFORMS,
              drawerProps: {
                title: "Data Stored",
                selectedDate: "2023-01",
                sector: []
              }
            },
            {
              key: "data-stored-in-azure-sql",
              label: "Data Stored in Azure SQL",
              tags: ["data", "storage", "azure", "sql"],
              drawerType: DrawerTypes.DAI_PLATEFORMS,
              drawerProps: {
                title: "Data Stored",
                selectedDate: "2023-01",
                sector: []
              }
            },
            {
              key: "data-stored-in-synapse",
              label: "Data Stored in Synapse",
              tags: ["data", "storage", "synapse"],
              drawerType: DrawerTypes.DAI_PLATEFORMS,
              drawerProps: {
                title: "Data Stored",
                selectedDate: "2023-01",
                sector: []
              }
            },
            {
              key: "data-stored-in-cosmos",
              label: "Data Stored in Cosmos",
              tags: ["data", "storage", "cosmos"],
              drawerType: DrawerTypes.DAI_PLATEFORMS,
              drawerProps: {
                title: "Data Stored",
                selectedDate: "2023-01",
                sector: []
              }
            },
        { key: "data-trend",  label: "Data Trend",  tags: ["trend","data","size"] },
        {
              key: "teradata-trend",
              label: "Teradata Trend",
              tags: ["teradata", "trend"],
              drawerType: DrawerTypes.OVERALL_DATA_GROWTH,
              drawerProps: {
                title: "Data Trend",
                selectedDate: "0M",
                sector: []
              }
        },
        {
              key: "azure-trend",
              label: "Azure Trend",
              tags: ["azure", "trend"],
              drawerType: DrawerTypes.OVERALL_DATA_GROWTH,
              drawerProps: {
                title: "Data Trend",
                selectedDate: "0M",
                sector: []
              }
        },

        // Processing
        { key: "adf-teradata", label: "ADF Pipelines & Teradata Jobs", tags: ["adf","teradata","pipelines","jobs","processing"] },
        {
              key: "adf-pipelines",
              label: "ADF Pipelines",
              tags: ["adf", "pipelines"],
              drawerType: DrawerTypes.TOTAL_PIPELINES,
              drawerProps: {
                title: "ADF Pipelines & Teradata Jobs",
                selectedDate: "0M",
                sector: []
              }
        },
        {
              key: "teradata-jobs",
              label: "Teradata Jobs",
              tags: ["teradata", "Jobs"],
              drawerType: DrawerTypes.TOTAL_PIPELINES,
              drawerProps: {
                title: "ADF Pipelines & Teradata Jobs",
                selectedDate: "0M",
                sector: []
              }
        },
        { key: "dbx-ytd",      label: "Databricks Clusters YTD",       tags: ["clusters","databricks","ytd","processing"] },
        {
              key: "databricks-clusters-ytd",
              label: "Databricks Clusters YTD",
              tags: ["databricks", "clusters", "ytd"],
              drawerType: DrawerTypes.TOTAL_CLUSTER,
              drawerProps: {
                title: "Databricks Clusters",
                selectedDate: "2023-01",
                sector: []
              }
        },

        // BI Usage
        { key: "pbi",           label: "Power BI",        tags: ["powerbi","bi","usage"] },
        {
              key: "power-bi-users",
              label: "Power BI Users",
              tags: ["power", "bi", "users"],
              drawerType: DrawerTypes.POWERBI_USERS,
              drawerProps: {
                title: "Power BI",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "power-bi-reports",
              label: "Power BI Reports",
              tags: ["power", "bi", "reports"],
              drawerType: DrawerTypes.POWERBI_USERS,
              drawerProps: {
                title: "Power BI",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "power-bi-inactive-reports",
              label: "Power BI Inactive Reports",
              tags: ["power", "bi", "inactive", "reports"],
              drawerType: DrawerTypes.POWERBI_USERS,
              drawerProps: {
                title: "Power BI",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "power-bi-datasets",
              label: "Power BI Datasets",
              tags: ["power", "bi", "datasets"],
              drawerType: DrawerTypes.POWERBI_USERS,
              drawerProps: {
                title: "Power BI",
                selectedDate: "2023-01",
                sector: []
              }
        },
        { key: "tableau",       label: "Tableau",         tags: ["tableau","bi","usage"] },
        {
              key: "tableau-licenses",
              label: "Tableau Licenses",
              tags: ["tableau", "licenses"],
              drawerType: DrawerTypes.TABLEAU_USERS,
              drawerProps: {
                title: "Tableau",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "tableau-global-users",
              label: "Tableau Global Users",
              tags: ["tableau", "global", "users"],
              drawerType: DrawerTypes.TABLEAU_USERS,
              drawerProps: {
                title: "Tableau",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "tableau-cockpit-users",
              label: "Tableau Cockpit Users",
              tags: ["tableau", "cockpit", "users"],
              drawerType: DrawerTypes.TABLEAU_USERS,
              drawerProps: {
                title: "Tableau",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "tableau-inactive-users-(global-&-cockpit)",
              label: "Tableau Inactive Users (Global & Cockpit)",
              tags: ["tableau", "inactive", "users"],
              drawerType: DrawerTypes.TABLEAU_USERS,
              drawerProps: {
                title: "Tableau",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "tableau-reports",
              label: "Tableau Reports",
              tags: ["tableau", "reports"],
              drawerType: DrawerTypes.TABLEAU_USERS,
              drawerProps: {
                title: "Tableau",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "tableau-datasets",
              label: "Tableau Datasets",
              tags: ["tableau", "datasets"],
              drawerType: DrawerTypes.TABLEAU_USERS,
              drawerProps: {
                title: "Tableau",
                selectedDate: "2023-01",
                sector: []
              }
        },
        { key: "pbi-trend",     label: "Power BI Trend",  tags: ["powerbi","trend","bi","usage"] },
        {
              key: "usage-trend",
              label: "Usage Trend",
              tags: ["usage", "trend"],
              drawerType: DrawerTypes.POWERBI_USER_GROWTH,
              drawerProps: {
                title: "Power BI Trend",
                selectedDate: "0M",
                sector: []
              }
        },
        {
              key: "dataset-trend",
              label: "Dataset Trend",
              tags: ["dataset", "trend"],
              drawerType: DrawerTypes.POWERBI_USER_GROWTH,
              drawerProps: {
                title: "Power BI Trend",
                selectedDate: "0M",
                sector: []
              }
        },
        { key: "tableau-trend", label: "Tableau Trend",   tags: ["tableau","trend","bi","usage"] },
        {
              key: "users-trend",
              label: "Users Trend",
              tags: ["users", "trend"],
              drawerType: DrawerTypes.TABLEAU_USER_GROWTH,
              drawerProps: {
                title: "Tableau Trend",
                selectedDate: "0M",
                sector: []
              }
        },
        {
              key: "dataset-trend",
              label: "Dataset Trend",
              tags: ["dataset", "trend"],
              drawerType: DrawerTypes.TABLEAU_USER_GROWTH,
              drawerProps: {
                title: "Tableau Trend",
                selectedDate: "0M",
                sector: []
              }
        },

        // Sustain YTD
        { key: "major-inc-ytd",    label: "Major INC YTD",               tags: ["major","inc","ytd","sustain"] },
        { key: "platform-outages", label: "Platform Outages YTD",        tags: ["platform","outages","sustain","ytd"] },
        {
              key: "legacy-edw-outages",
              label: "Legacy EDW Outages",
              tags: ["Legacy", "edw", "outages"],
              drawerType: DrawerTypes.OUTAGES,
              drawerProps: {
                title: "Platform Outages YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "azure-outages",
              label: "Azure Outages",
              tags: ["azure", "outages"],
              drawerType: DrawerTypes.OUTAGES,
              drawerProps: {
                title: "Platform Outages YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "databricks-outages",
              label: "Databricks Outages",
              tags: ["databricks", "outages"],
              drawerType: DrawerTypes.OUTAGES,
              drawerProps: {
                title: "Platform Outages YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "presto-outages",
              label: "Presto Outages",
              tags: ["presto", "outages"],
              drawerType: DrawerTypes.OUTAGES,
              drawerProps: {
                title: "Platform Outages YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "power-bi-outages",
              label: "Power BI Outages",
              tags: ["power","bi", "outages"],
              drawerType: DrawerTypes.OUTAGES,
              drawerProps: {
                title: "Platform Outages YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "other-outages",
              label: "Other Outages",
              tags: ["other", "outages"],
              drawerType: DrawerTypes.OUTAGES,
              drawerProps: {
                title: "Platform Outages YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },
        { key: "unplanned-dt",     label: "Unplanned Platform Downtime", tags: ["unplanned","platform","sustain","downtime"] },
        {
              key: "teradata",
              label: "Teradata",
              tags: ["teradata", "Unplanned", "Downtime"],
              drawerType: DrawerTypes.UNPLANNED_DOWNTIME,
              drawerProps: {
                title: "Unplanned Platform Downtime YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "powerbi",
              label: "PowerBI",
              tags: ["powerbi", "Unplanned", "Downtime"],
              drawerType: DrawerTypes.UNPLANNED_DOWNTIME,
              drawerProps: {
                title: "Unplanned Platform Downtime YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "databricks",
              label: "Databricks",
              tags: ["databricks","Unplanned", "Downtime"],
              drawerType: DrawerTypes.UNPLANNED_DOWNTIME,
              drawerProps: {
                title: "Unplanned Platform Downtime YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "others",
              label: "Others",
              tags: ["others", "Unplanned", "Downtime"],
              drawerType: DrawerTypes.UNPLANNED_DOWNTIME,
              drawerProps: {
                title: "Unplanned Platform Downtime YTD",
                selectedDate: "2023-01",
                sector: []
              }
        },

        // Cost
        { key: "ytd-spend",         label: "YTD Spend",              tags: ["spend","ytd","cost"] },
        {
              key: "azure-cost",
              label: "Azure Cost",
              tags: ["azure", "cost"],
              drawerType: DrawerTypes.YTD_SPEND,
              drawerProps: {
                title: "YTD Spend",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "databricks-cost",
              label: "Databricks Cost",
              tags: ["databricks","cost"],
              drawerType: DrawerTypes.YTD_SPEND,
              drawerProps: {
                title: "YTD Spend",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "teradata-cost",
              label: "Teradata Cost",
              tags: ["teradata", "Cost"],
              drawerType: DrawerTypes.YTD_SPEND,
              drawerProps: {
                title: "YTD Spend",
                selectedDate: "2023-01",
                sector: []
              }
        },
        { key: "ri-savings",        label: "RI Savings",             tags: ["ri","savings","cost"] },
        { key: "avg-monthly-trend", label: "Avg Monthly Cost Trend", tags: ["monthly","cost","trend"] },
        {
              key: "azure-cost-trend",
              label: "Azure Cost Trend",
              tags: ["azure", "cost", "trend"],
              drawerType: DrawerTypes.AVG_MONTHLY_COST_TREND,
              drawerProps: {
                title: "Avg Monthly Cost Trend",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "databricks-cost-trend",
              label: "Databricks Cost Trend",
              tags: ["databricks","cost", "trend"],
              drawerType: DrawerTypes.AVG_MONTHLY_COST_TREND,
              drawerProps: {
                title: "Avg Monthly Cost Trend",
                selectedDate: "2023-01",
                sector: []
              }
        },
        {
              key: "teradata-cost-trend",
              label: "Teradata Cost Trend",
              tags: ["teradata", "Cost", "trend"],
              drawerType: DrawerTypes.AVG_MONTHLY_COST_TREND,
              drawerProps: {
                title: "Avg Monthly Cost Trend",
                selectedDate: "2023-01",
                sector: []
              }
        },
      ],
    },

    {
      key: "storagesummary",
      title: "Storage Summary",
      route: "/dataestate/storagesummary",
      items: [
        // Data Stored in
        { key: "teradata",  label: "Teradata",     tags: ["teradata","stored","data","storage"] },
        { key: "adls-blob", label: "ADLS & Blob",  tags: ["adls","blob","data","storage","stored"] },
        { key: "azuresql",  label: "Azure SQL",    tags: ["azure","sql","storage"] },
        { key: "synapse",   label: "Synapse",      tags: ["synapse","stored","data","storage"] },
        { key: "cosmos",    label: "Cosmos",       tags: ["cosmos","stored","data","storage"] },

        // Data Trend
        { key: "teradata-trend", label: "Teradata Trend", tags: ["teradata","trend","data"] },
        { key: "azure-trend",    label: "Azure Trend",    tags: ["azure","trend","data"] },
      ],
    },

    {
      key: "queriessummary",
      title: "Query Summary",
      route: "/dataestate/queriessummary",
      items: [
        // Engines
        { key: "presto-queries",   label: "Presto Queries",   tags: ["presto","queries"] },
        { key: "teradata-queries", label: "Teradata Queries", tags: ["teradata","queries"] },

        // Trend
        { key: "presto-query-trend",   label: "Presto Query Trend",   tags: ["presto","trend","query"] },
        { key: "teradata-query-trend", label: "Teradata Query Trend", tags: ["teradata","trend","query"] },
      ],
    },

    {
      key: "data-processing",
      title: "Data Processing Summary",
      route: "/dataestate/data-processing",
      items: [
        // Data Processing
        { key: "adf-pipelines",        label: "ADF Pipelines",        tags: ["adf","pipelines","processing"] },
        { key: "teradata-jobs",        label: "Teradata Jobs",        tags: ["teradata","jobs","processing"] },
        { key: "azure-pipeline-trend", label: "Azure Pipeline Trend", tags: ["azure","trend","pipeline","processing"] },
        { key: "teradata-job-trend",   label: "Teradata Job Trend",   tags: ["teradata","trend","job","processing"] },

        // Compute Clusters
        { key: "databricks",       label: "Databricks",       tags: ["databricks","clusters","compute"] },
        { key: "databricks-trend", label: "Databricks Trend", tags: ["databricks","trend","clusters","compute"] },

        // Performance
        { key: "dbx-exec-time", label: "Databricks Job Execution Time", tags: ["databricks","job","execution","time","performance"] },
        { key: "td-exec-time",  label: "Teradata Job Execution Time",   tags: ["teradata","job","execution","time","performance"] },

        // Reliability
        { key: "azuresql-uptime", label: "Azure SQL Uptime", tags: ["azure","sql","uptime","reliability"] },
        { key: "synapse-uptime",  label: "Synapse Uptime",   tags: ["synapse","uptime","reliability"] },
      ],
    },

    {
      key: "biApplicationSummary",
      title: "BI Application Summary",
      route: "/dataestate/biApplicationSummary",
      items: [
        // Power BI
        { key: "pbi-reports",        label: "Reports",        tags: ["reports","power bi"] },
        { key: "pbi-datasets",       label: "Datasets",       tags: ["datasets","power bi"] },
        { key: "pbi-workspaces",     label: "Workspaces",     tags: ["workspaces","power bi"] },
        { key: "pbi-users",          label: "Users",          tags: ["users","power bi"] },
        { key: "pbi-datasets-trend", label: "Datasets Trend", tags: ["datasets","trend","power bi"] },
        { key: "pbi-usage-trend",    label: "Usage Trend",    tags: ["usage","trend","power bi"] },

        // Tableau
        { key: "tbl-reports",        label: "Reports",        tags: ["reports","tableau"] },
        { key: "tbl-datasets",       label: "Datasets",       tags: ["datasets","tableau"] },
        { key: "tbl-licenses",       label: "Licenses",       tags: ["licenses","tableau"] },
        { key: "tbl-cockpit-users",  label: "Cockpit Users",  tags: ["cockpit","tableau","users"] },
        { key: "tbl-global-users",   label: "Global Users",   tags: ["users","tableau","global"] },
        { key: "tbl-datasets-trend", label: "Datasets Trend", tags: ["datasets","trend","tableau"] },
        { key: "tbl-usage-trend",    label: "Usage Trend",    tags: ["usage","trend","tableau"] },
      ],
    },

    // NEW: Cost Summary (from your list)
    {
      key: "costSummary",
      title: "Cost Summary",
      route: "/dataestate/costSummary",
      items: [
        // Azure
        { key: "azure-cost",       label: "Cost",       tags: ["cost","azure"] },
        { key: "azure-cost-trend", label: "Cost Trend", tags: ["cost","trend","azure"] },

        // Databricks
        { key: "databricks-cost",       label: "Cost",       tags: ["cost","databricks"] },
        { key: "databricks-cost-trend", label: "Cost Trend", tags: ["cost","trend","databricks"] },

        // Teradata
        { key: "teradata-cost",       label: "Cost",       tags: ["cost","teradata"] },
        { key: "teradata-cost-trend", label: "Cost Trend", tags: ["cost","trend","teradata"] },
      ],
    },

    {
      key: "majorIncident",
      title: "Major INC Summary",
      route: "/dataestate/majorIncident",
      items: [
        { key: "details",      label: "Major INC Details",           tags: ["major","inc","details"] },
        { key: "outages",      label: "Outages",                      tags: ["outages","major","inc"] },
        { key: "mttr",         label: "Mean time To Resolve (MTTR)",  tags: ["mttr","mean","resolve","time","major","inc"] },
        { key: "availability", label: "Availability",                 tags: ["availability","major","inc"] },
        { key: "inc-details",  label: "INC Details",                  tags: ["inc","major","details"] },
      ],
    },
  ],
};
